module.exports = __webpack_public_path__ + "img/background_event.fdf7d26d.png";